import * as React from 'react';
import Block from 'lqa-ui/lib/Components/Block';
import NonIdealState from 'lqa-ui/lib/Components/NonIdealState';
import FramePage from 'components/framePage/FramePage';
import { useTranslation } from 'react-i18next';

export const FatalError = () => {
    const {t} = useTranslation();
    return (
        <FramePage title={t('error.Fatal error')}>
            <Block>
                <NonIdealState
                    title={t('error.You had a fatal error')}
                    icon="illustration-fatal"
                />
            </Block>
        </FramePage>
    );
};
